export enum PreferenceType {
  BOOLEAN = 'boolean',
  NUMBER = 'number',
  STRING = 'string',
}

export type PreferenceValue = string | number | boolean
